export default {
  beforeCreate() {
    const computed = (this.$options.computedProps || []).reduce((obj, prop) => {
      obj[prop] = () => this.data.data[prop]
      return obj
    }, {})
    this.$options.computed = Object.assign({}, this.$options.computed, computed)
  }
}
